// extracted by mini-css-extract-plugin
module.exports = {"toggle":"CompareModeToggle_toggle__cd9H6","isActive":"CompareModeToggle_isActive__dRuju","icon":"CompareModeToggle_icon__jQlK3"};